import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, useLocation } from 'react-router-dom';

const AuthRoute = (props) => {
  const location = useLocation();
  const token = localStorage.getItem('token')
  if (!token || token === null || token === undefined) return <Redirect to="/login" />;
  if (token && location.pathname === '/login') return <Redirect to="/dashboard" />;
  return <Route {...props} />;
};

const mapStateToProps = (state) => ({
  isAuthUser: state.common.isAuthUser,
});

export default connect(mapStateToProps, null)(AuthRoute);
